import { DisplayLayout } from 'components/Collection/Collection.const';
import { Config, UniversalCollection, UniversalConfig } from '../interfaces';
import { contains, isEmpty, parseConfig } from 'util/index';
import { COLLECTION_OPTIONS } from 'globalConst/const';

/**
 * @class
 * A representation of a universal collection
 *
 * @param {object} collection - collection model
 * @param {object} sectionConfig - universal api config
 * @param {object} ownProps - collection props
 */
export default class Collection {
  id: string;
  uuid: string;
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  display: string = DisplayLayout.CAROUSEL;
  rows: number = undefined;
  variationKey: string;

  disableLazyFetch: boolean;
  contentTypeId: string;

  isHighlighted = false;
  hideTitle = false;

  options: string[];
  config: Config;

  hasOption(val: string): boolean {
    return this.options && this.options.includes(val);
  }

  hasConfig(configKey: string, defaultValue = ''): string {
    try {
      return this.config[configKey];
    } catch {
      return defaultValue;
    }
  }

  constructor(collection: UniversalCollection, config: UniversalConfig[], options: string[]) {
    if (isEmpty(collection)) {
      return null;
    }

    this.disableLazyFetch = collection.disableLazyFetch;
    this.contentTypeId = collection.type;
    this.uuid = collection.id;
    this.id = collection.id;

    this.title = collection.title;
    this.slug = collection.slug;
    this.description = collection.description;
    this.subtitle = collection.description;

    // collection.config will be provided if its experiments
    this.config = {
      ...parseConfig(config),
      ...parseConfig(collection.config),
    };

    this.options = [];
    if (!isEmpty(options)) {
      this.options = options;
    }

    // collection.options will be provided if its experiments
    if (!isEmpty(collection.options)) {
      this.options = [...this.options, ...collection.options];
    }

    this.variationKey = this.config.VariationKey;

    const presentationType = this.config.PresentationType;

    if (presentationType && contains(Object.values(DisplayLayout), presentationType, true)) {
      this.display = presentationType;
    }

    if (contains([DisplayLayout.LIST, DisplayLayout.GRID], presentationType, true)) {
      this.display = DisplayLayout.TILES;
    }

    const rows = this.config.Rows;
    if (!isNaN(+rows)) {
      this.rows = Math.max(+rows, 1);
    }

    this.isHighlighted = contains(this.options, COLLECTION_OPTIONS.HIGHLIGHT);
    this.hideTitle = contains(this.options, COLLECTION_OPTIONS.HIDE_TITLE);
    this.hasOption = this.hasOption.bind(this);
  }
}
